import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'children'> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[var(--primary)] text-[var(--primary-foreground)] hover:brightness-110 focus:ring-[var(--primary)]',
    secondary: 'bg-[var(--secondary)] text-[var(--secondary-foreground)] hover:bg-gray-700 focus:ring-[var(--secondary)]',
    ghost: 'bg-transparent text-[var(--text-muted)] hover:bg-gray-100 hover:text-[var(--text-main)]',
    danger: 'bg-[var(--danger)] text-white hover:brightness-90 focus:ring-[var(--danger)]',
    outline: 'border-2 border-[var(--primary)] text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white'
  };
  const sizes = {
    sm: 'h-8 px-3 text-sm',
    md: 'h-10 px-4 text-base',
    lg: 'h-12 px-6 text-lg'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-206">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-207" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-208">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-209">{rightIcon}</span>}
    </motion.button>;
}